<template>
    <div>
        <div style="margin-top: 30px;display: flex;justify-content: center;">
            <div class="class-chinaMapChart" ref="vChinaMapChart" ></div>
        </div>
    </div>

</template>

<script>
//    import echarts from 'echarts';
    import '../../../node_modules/echarts/map/js/china.js' // 引入中国地图数据
    export default {
        name: "DevCheck",
        props: ["userJson"],
        data () {
            return {
                chinaMapChart: null
            }
        },
        mounted(){
            this.chinaConfigure();
        },
        beforeDestroy() {
            if (!this.chinaMapChart) {
                return;
            }
            this.chinaMapChart.dispose();
            this.chinaMapChart = null;
        },
        methods: {
            chinaConfigure() {
                console.log(this.userJson)
                this.chinaMapChart = this.g_echarts.init(this.$refs.vChinaMapChart); //这里是为了获得容器所在位置
                window.onresize = this.chinaMapChart.resize;
                this.chinaMapChart.setOption({ // 进行相关配置
                    backgroundColor: "#02AFDB",
                    tooltip: {}, // 鼠标移到图里面的浮动提示框
                    dataRange: {
                        show: false,
                        min: 0,
                        max: 100000,
                        text: ['High', 'Low'],
                        realtime: true,
                        calculable: true,
                        color: [
                            '#FF0000',
                            '#FF9000',
                            '#FFC000',
                            '#50A0A0',
                            '#A0A0A0',
                            '#105090',
                            '#1070A0',
                            '#107010',
                            'orangered',
                            'lightskyblue'
                        ]
                    },
                    geo: { // 这个是重点配置区
                        map: 'china', // 表示中国地图
                        roam: true, // 是否开启鼠标缩放和平移漫游
                        center: [108.97, 34.71], // 当前视角的中心点，用经纬度表示
                        zoom: 1.1,  // 当前视角的缩放比例
                        label: {    // 图形上的文本标签，可用于说明图形的一些数据信息，比如值，名称等
                            normal: {
                                show: true, // 是否显示对应地名
                                textStyle: {
                                    color: 'rgba(0,0,0,0.4)'
                                }
                            }
                        },
                        itemStyle: { // 地图区域的多边形 图形样式
                            normal: {
                                borderColor: 'rgba(0, 0, 0, 0.2)' // 图形的描边颜色
                            },
                            emphasis: {
                                areaColor: null,
                                shadowOffsetX: 0,
                                shadowOffsetY: 0,
                                shadowBlur: 20,
                                borderWidth: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        }
                    },
                    series: [{
                        type: 'scatter',
                        coordinateSystem: 'geo' // 对应上方配置
                    },
                        {
                            name: '商户量', // 浮动框的标题
                            type: 'map',
                            geoIndex: 0,
                            data: [{
                                "name": "湖北",
                                "value": 100000
                            }, {
                                "name": "河南",
                                "value": 90000
                            }, {
                                "name": "广东",
                                "value": 80000
                            }, {
                                "name": "陕西",
                                "value": 70000
                            }, {
                                "name": "江苏",
                                "value": 70000
                            }, {
                                "name": "安徽",
                                "value": 60000
                            }, {
                                "name": "浙江",
                                "value": 50000
                            }, {
                                "name": "台湾",
                                "value": 40000
                            }, {
                                "name": "甘肃",
                                "value": 30000
                            }, {
                                "name": "北京",
                                "value": 20000
                            }, {
                                "name": "四川",
                                "value": 10000
                            }, {
                                "name": "上海",
                                "value": 142
                            }, {
                                "name": "河北",
                                "value": 44
                            }, {
                                "name": "黑龙江",
                                "value": 44
                            }, {
                                "name": "贵州",
                                "value": 44
                            }, {
                                "name": "深圳",
                                "value": 92
                            }]
                        }
                    ]
                })
            }
        }
    }
</script>

<style>

    .class-chinaMapChart {
        width: 100%;
        height: 500px;
    }


</style>